export const ROWS = 5;
export const COLS = 5;
// v3 adds chillMode + dripStartedAt to the persisted shape; older saves
// (which lack these) load fine but with chillMode falsy and dripStartedAt
// undefined, so this could be a non-bumping additive change. Bumping anyway
// keeps the migration story uniform.
export const STORAGE_KEY = 'bsidevideo-state-v3';
export const ONBOARDED_KEY = 'bsidevideo-onboarded-v1';
export const CHILL_KEY = 'bsidevideo-chill-v1';
// Day 0 of the puzzle calendar. Movie + word index are derived from days
// since this epoch.
export const EPOCH_UTC = Date.UTC(2025, 9, 1); // Oct 1 2025
// Per-row drip durations (ms), indexed by row. Row 1 is generous so the
// opener guess never feels pressure; later rows tighten fast. Single
// calibration knob — retune after playtest.
export const DRIP_MS: readonly number[] = [90_000, 60_000, 45_000, 30_000, 20_000];
